

import React from 'react';
import { VideoMode } from '../../../../../../types';

import NoControlsPlayer from './NoControlsPlayer';
import ShootstaPlayer from './ShootstaPlayer';
import WithControlsPlayer from './WithControlsPlayer';















const Video = (props) => {
  const { mode, ...otherProps } = props;

  if (mode === VideoMode.SHOOTSTA_PLAYER) {
    return <ShootstaPlayer {...otherProps} />;
  }

  if (mode === VideoMode.PLAYER_CONTROLS) {
    return <WithControlsPlayer {...otherProps} />;
  }

  if (mode === VideoMode.PLAYER_NO_CONTROLS) {
    return <NoControlsPlayer {...otherProps} />;
  }

  return null;
};

export default Video;